module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-10.7f11377d.jpg";